import Matomo from './Matomo.js';

export default Matomo;
